<template>
  <div>
    <v-card class="mb-3">
      <progress-bar :show="busy" class="my-0"></progress-bar>
      <v-card-title primary-title class="grey lighten-4">
        <h3 class="headline mb-0">{{ $t('your_bookings') }}</h3>
      </v-card-title>
      <v-divider class="mb-2" ></v-divider>
      <v-divider v-if="bookings.length > 0"></v-divider>
      <div class="pb-2" v-for="(booking, index) in bookings" :key="index">
        <v-card-text >
          <v-layout row>
            <v-flex xs12 md8>
              <h1 class="title">{{ booking.trip_name }}</h1>
              <div>{{ booking.date_from }} - {{ booking.date_to }}</div>
              <div>Booking no: {{ booking.booking_id }}</div>
            </v-flex>

            <v-flex v-if="booking.client_id==user.client_id" xs12 md4 style="text-align:right;">
              <v-chip v-if="booking.status_id==10" color="primary" text-color="white">Request</v-chip>
              <v-chip v-if="booking.status_id==30" color="secondary" text-color="white">Offered</v-chip>
              <v-chip v-if="booking.status_id==50" color="red" text-color="white">Not paid</v-chip>
              <v-chip v-if="booking.status_id==70" color="orange" text-color="white">Deposit paid</v-chip>
              <v-chip v-if="booking.status_id==80" color="green" text-color="white">Fully paid</v-chip>
            </v-flex>

          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
      </div>
      <div class='pa-4' v-if="bookings.length == 0">
        <i>No bookings</i>
      </div>
    </v-card>
    <v-card v-if="invoices_all.length > 0" class="mb-3">
      <v-card-title primary-title class="grey lighten-4">
        <h3 class="headline mb-0">{{ $t('invoices') }}</h3>
      </v-card-title>
      <div>
        <table class="v-table theme--light">
          <thead>
            <tr>
              <td>Invoice no.</td>
              <td>Booking no.</td>
              <td>Total amount</td>
              <td>Due payment</td>
              <td>Due date</td>
              <td></td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(invoice, index) in invoices_all" :key="index">
              <td><a :href="invoice_url + invoice.token" target="_blank">{{ invoice.fortnox_invoice_no }}</a></td>
              <td>{{ invoice.booking_id }}</td>
              <td>{{ invoice.amount_total }} {{ invoice.currency }}</td>
              <td>{{ (invoice.amount_total-invoice.paid_amount).toFixed(2) }} {{ invoice.currency }}</td>
              <td>{{ invoice.due_date }}</td>
              <td>
                <router-link :to="'/pay/' + invoice.token" v-if="invoice.status<100 && invoice.amount_total-invoice.paid_amount>0">
                  <v-btn class="ml-0" color="primary">Pay</v-btn>
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </v-card>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
export default {
  name: 'home-view',
  data: () => ({
    bookings: [],
    invoices_due: [],
    invoices_all: [],
    busy: true,
    invoice_url: process.env.INVOICE_PDF_URL
  }),

  computed: mapGetters({
    user: 'authUser'
  }),

  mounted() {
    axios.get(process.env.API_URL+'/bookings_invoices')
    .then((response) => {
      if(response.data.bookings){
        this.bookings = response.data.bookings
      }
      if(response.data.invoices_due){
        this.invoices_due = response.data.invoices_due
      }
      if(response.data.invoices_all){
        this.invoices_all = response.data.invoices_all
      }
      this.busy = false
    })
    .catch((error) => {
      this.busy = false
    })
  },

  metaInfo () {
    return { title: this.$t('home') }
  }
}
</script>



// WEBPACK FOOTER //
// bookings.vue?fd18767c